import { useState } from 'react';
import { COLORS, FONTS } from '../../styles/tokens';
import type { ColorTheme } from '../../styles/tokens';
import { IconUploader } from '../../components/app/IconUploader';

interface AddAppFormProps {
  onSubmit: (name: string, url: string, description: string, team: string, category: string, icon: File | null) => void;
  isDark: boolean;
  colors: ColorTheme;
}

/**
 * Inline "add new app" form used by the admin App Management page. Captures
 * the five display/metadata fields; submission delegates to the parent.
 */
export function AddAppForm({ onSubmit, isDark, colors }: AddAppFormProps): React.JSX.Element {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  const [team, setTeam] = useState('');
  const [category, setCategory] = useState('');
  const [icon, setIcon] = useState<File | null>(null);

  const inputStyle: React.CSSProperties = {
    height: '36px',
    padding: '0 12px',
    borderRadius: '6px',
    width: '100%',
    border: `1px solid ${colors.border}`,
    backgroundColor: isDark ? COLORS.dark.cardAlt : COLORS.light.cardAlt,
    color: colors.text,
    fontFamily: FONTS.body,
    fontSize: '13px',
    outline: 'none',
  };

  return (
    <div style={{
      padding: '16px',
      borderRadius: '10px',
      border: `1px solid ${colors.border}`,
      marginBottom: '16px',
      backgroundColor: isDark ? COLORS.dark.card : COLORS.light.card,
    }}>
      <div className="vx-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <input placeholder="App Name" value={name} onChange={e => setName(e.target.value)} style={inputStyle} />
        <input placeholder="URL" value={url} onChange={e => setUrl(e.target.value)} style={inputStyle} />
        <input placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} style={inputStyle} />
        <input placeholder="Team" value={team} onChange={e => setTeam(e.target.value)} style={inputStyle} />
        <input placeholder="Category" value={category} onChange={e => setCategory(e.target.value)} style={inputStyle} />
        <div style={{ gridColumn: '1 / -1' }}>
          <div style={{ fontFamily: FONTS.heading, fontSize: '9px', letterSpacing: '0.12em', textTransform: 'uppercase', color: colors.textSecondary, marginBottom: '4px' }}>
            Logo
          </div>
          <IconUploader
            isDark={isDark}
            colors={{ text: colors.text, textSecondary: colors.textSecondary, border: colors.border, card: colors.card }}
            onChange={setIcon}
          />
        </div>
        <button
          onClick={() => onSubmit(name, url, description, team, category, icon)}
          style={{
            height: '36px',
            borderRadius: '6px',
            border: 'none',
            background: isDark ? 'linear-gradient(90deg, #0266C6, #00407D)' : 'linear-gradient(90deg, #01A9ED, #0165C6)',
            color: '#FFF',
            fontFamily: FONTS.heading,
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            cursor: 'pointer',
          }}
        >
          Create App
        </button>
      </div>
    </div>
  );
}
